<template>
    <v-layer ref="layer">
        <v-image v-for="img in imageConfigs" :key="img.id" :config="img"></v-image>
        <v-rect ref="grid" :config="gridRectConfig"></v-rect>
    </v-layer>
</template>

<script>
import GridCornerRenderer from './grid/GridCornerRenderer';

export default {
    props: {
        renderContext: {
            type: Object,
            required: true,
        },
        stage: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            gridRenderer: Object.seal(new GridCornerRenderer()),
            gridTile: Object.seal(document.createElement('canvas')),
        };
    },
    computed: {
        areaConfig: function() {
            const gridSpace = this.renderContext.gridSpace;
            const nw = gridSpace.gridToStage(this.stage.bounds.nw, 'nw');
            const se = gridSpace.gridToStage(this.stage.bounds.se, 'se');
            return {
                width: se.x - nw.x,
                height: se.y - nw.y,
                position: nw,
            };
        },
        gridRectConfig() {
            let renderConfig = {
                blueprint: this.renderContext.gridSpace.blueprint,
                pixelRatio: this.renderContext.pixelRatio,
            };

            let gridSpec = this.gridRenderer.render(renderConfig, this.gridTile);

            let config = {
                fillPatternOffset: gridSpec.offset,
                fillPatternImage: gridSpec.image,
                fillPatternScale: { x: gridSpec.scale, y: gridSpec.scale },
                listening: false,
            };

            // We need to manually call fillPatternImage here because Konva can't respond
            // to the image size changing without the image elemnt itself changes
            const node = this.$refs.grid && this.$refs.grid.getNode();
            if (node) {
                node.fillPatternImage(gridSpec.image);
            }

            return Object.assign(config, this.areaConfig);
        },
        imageConfigs: function() {
            if (!this.stage.elements) {
                return [];
            }

            const gridSpace = this.renderContext.gridSpace;
            let configs = [];
            let images = this.stage.elements.filter(e => e.asset);
            const scaleFacotr = 50 / this.stage.grid.size;
            let scale = { x: gridSpace.scale * scaleFacotr, y: gridSpace.scale * scaleFacotr };

            for (let img of images) {
                let pos = gridSpace.gridToStage(img.pos);
                let config = {
                    image: img.asset['@data'],
                    position: pos,
                    scale,
                };
                configs.push(config);
            }

            return configs;
        },
    },
};
</script>
